import { useContext }  from "react";
import { ValuesContext } from "contexts/ValuesContext";

export const useValues = () => useContext(ValuesContext)
